import type { CommissionRate } from '@hue/contracts';
import { formatCurrency } from '@hue/design-system';
import { formatPercent } from './sale-cart.js';

export function commissionRateLabel(rate: CommissionRate): string {
  return rate.rateType === 'PERCENT'
    ? formatPercent(rate.rateValue)
    : `${formatCurrency(rate.rateValue, 'BRL')} por unidade`;
}
